exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".risk-score[data-v-e9d2fa12]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;height:41px}.risk-score[data-v-e9d2fa12] .el-rate__icon{font-size:41px !important}", ""]);

// exports
